import React, { memo } from "react";
import { Drawer } from "@mui/material";
import { styled } from "@mui/material/styles";

const DrawerMain = styled(Drawer)(({ theme }) => ({
  width: 240,
  "& .MuiDrawer-paper": {
    width: 240,
    backgroundColor: "#fff",
    padding: "20px 0px",
  },
}));
const MainContact = styled("div")(({ theme }) => ({
  paddingTop: "10px",
  "& li ": {
    background: "#fff",
    color: "#000000",
    "& button": { color: "#000000" },
  },
  "& li.active ": {
    background: "#fff",
    color: "#000000",
    "& button": { color: "#000000" },
  },
  "& .css-68iyd li.active": {
    background: "#fff",
    color: "#000000",
  },
  "& button": {
    color: "#fff",
  },
}));

const MobileSide = (props) => {
  return (
    <>
      <DrawerMain
        anchor="left"
        open={props.isDrawerOpen}
        onClose={props.handleCloseNavMenu}
      >
        <MainContact>{props.children}</MainContact>
      </DrawerMain>
    </>
  );
};

export default memo(MobileSide);
